export default {
  title: "You're leaving bloomingdales.com.",
  text: "You're heading to the Department Stores National Bank (DSNB) website managed by Citibank, N.A. DSNB issues the Bloomingdale's Credit Card and is an affiliate of Bloomingdale's and Citibank. The DSNB website has a different privacy policy and may have different security than bloomingdales.com.",
  subtext: 'Would you like to continue?',
  cancel: 'NO, THANKS',
  continue: 'CONTINUE',
  oopsMessage: 'Oops! Looks like we’re experiencing some technical difficulties. Please try again.',
  loading: 'Loading...',
  noCards: {
    text1: "We’re sorry, but we are unable to access your Bloomingdale's Credit Card account.",
    text2: "It could be because your card has not yet been added to your Bloomingdale's profile. To be able to manage your account online, please add it to your profile now.",
    text3: "If your card has already been added to your Bloomingdale's profile, or if you continue to have difficulties accessing your account,  please contact Customer Service at 1-888-257-67621-888-257-6762.",
    addMyCard: 'ADD MY CARD',
  },
};
